import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
const mobileStyles = css(["a{padding-left:18px;}li{padding-left:24px;}"]);
const defaultStyles = css(["font-size:16px;a{padding-left:18px;}"]);
export const MenuListItem = styled.li.withConfig({
  displayName: "MenuList__MenuListItem",
  componentId: "sc-jclps5-0"
})(["", ""], _ref => {
  let {
    lastOfGroup
  } = _ref;
  return lastOfGroup && css(["&:after{display:block;position:absolute;bottom:0.5px;left:0;right:0;width:100%;height:1px;content:'';background-color:", ";}"], _ref2 => {
    let {
      theme
    } = _ref2;
    return theme.colors.terciaryL;
  });
});
export const MenuLink = styled.a.withConfig({
  displayName: "MenuList__MenuLink",
  componentId: "sc-jclps5-1"
})([""]);
export const MenuList = styled.ul.withConfig({
  displayName: "MenuList",
  componentId: "sc-jclps5-2"
})(["li{display:flex;position:relative;align-items:center;width:", ";height:55px;padding:6px 12px;color:", ";transition:color 0.15s ease;&:hover{background-color:", ";color:", ";a{color:", ";}}}a{display:block;position:relative;flex-grow:1;padding:9px 16px;color:", ";transition:color 0.15s ease;}strong,small{display:block;}strong{", ";font-weight:600;color:", ";svg{position:relative;top:1px;flex-shrink:0;margin-left:3px;}}small{", ";}", ";"], _ref3 => {
  let {
    wide
  } = _ref3;
  return wide ? '300px' : null;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.fontL;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.terciaryL;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.font;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colors.font;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.colors.fontL;
}, getFont(-1, 'compact'), _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.font;
}, getFont(-2, 'compact'), _ref10 => {
  let {
    mobile
  } = _ref10;
  return mobile ? mobileStyles : defaultStyles;
});
export const Highlight = styled.span.withConfig({
  displayName: "MenuList__Highlight",
  componentId: "sc-jclps5-3"
})(["background-color:", ";color:", ";", ";padding:2px 4px;border-radius:15px;position:relative;top:-14px;left:-8px;"], _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.colors.secondary;
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.colors.terciaryLL;
}, getFont(-3, 'compact'));